<template>
  <el-collapse id="benefitTab" v-model="activeCollapses">
    <el-collapse-item v-for="(item, index) in collapses" :key="item.key" :name="item.key">
      <template #title> {{ index + 1 }}.&nbsp;{{ $t(item.title) }} </template>
      <div v-for="(child, x) in item.desc" class="question_class mb-4" :key="x">
        <p class="mb-4">
          {{ $t(child.question) }}
        </p>
        <div class="font_normal">
          <p v-for="(ans, y) in child.answer" v-html="$t(ans)" :key="y" :class="child.subAnswer ? 'mb-2' : 'mb-3'"></p>
          <ul v-if="child.subAnswer">
            <li v-for="(subAns, y) in child.subAnswer" v-html="$t(subAns)" :key="y" class="ml-3"></li>
          </ul>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'Faq',
  data() {
    return {
      activeCollapses: ['1', '2'],
      collapses: [
        {
          key: '1',
          title: 'promotion.referAFriend.faq.general.title',
          desc: [
            {
              question: 'promotion.referAFriend.faq.general.question1',
              answer: ['promotion.referAFriend.faq.general.answer1'],
              subAnswer: [
                'promotion.referAFriend.faq.general.answer1a',
                'promotion.referAFriend.faq.general.answer1b',
                'promotion.referAFriend.faq.general.answer1c'
              ]
            }
          ]
        },
        {
          key: '2',
          title: 'promotion.referAFriend.faq.bonusRedemption.title',
          desc: [
            {
              question: 'promotion.referAFriend.faq.bonusRedemption.question1',
              answer: ['promotion.referAFriend.faq.bonusRedemption.answer1'],
              subAnswer: [
                'promotion.referAFriend.faq.bonusRedemption.answer1a',
                'promotion.referAFriend.faq.bonusRedemption.answer1b',
                'promotion.referAFriend.faq.bonusRedemption.answer1c',
                'promotion.referAFriend.faq.bonusRedemption.answer1d',
                'promotion.referAFriend.faq.bonusRedemption.answer1e'
              ]
            },
            {
              question: 'promotion.referAFriend.faq.bonusRedemption.question2',
              answer: [
                'promotion.referAFriend.faq.bonusRedemption.answer2',
                'promotion.referAFriend.faq.bonusRedemption.answer2a'
              ]
            },
            {
              question: 'promotion.referAFriend.faq.bonusRedemption.question3',
              answer: ['promotion.referAFriend.faq.bonusRedemption.answer3']
            }
          ]
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#benefitTab /deep/ {
  border: none;
  .el-collapse-item {
    &:not(:last-child) {
      .el-collapse-item__header {
        border-bottom: 1px solid #ebeef5;
      }
    }
    .el-collapse-item__header {
      border-bottom: 1px solid #ebeef5;
    }

    .el-collapse-item__header {
      color: #000;
      font-size: 16px;
      font-weight: 500;
      padding: 0 24px;
    }

    .el-collapse-item__content {
      color: #000;
      font-size: 14px;
      border: none;
      padding: 22px 24px 14px;
    }

    .el-collapse-item__wrap {
      &:not(:last-child) {
        border-bottom: 1px solid #ebeef5;
      }
    }

    .el-collapse-item__arrow {
      font-weight: bold;
      transform: rotate(90deg);
      &.is-active {
        transform: rotate(-90deg);
      }
    }
  }
}
.question_class {
  font-weight: bold;
}
.font_normal {
  font-weight: normal;
}
li {
  list-style-type: disc;
  margin-left: 20px;
}
</style>
